import 'rc-tooltip/assets/bootstrap.css';
import './FreelanceList.scss'

import {
  DEFAULT_SORTING,
  FIELD_KEYS,
  FIELD_TYPES,
  FILTER_GROUPS,
  FILTER_KEYS,
  FILTER_SHORTCUTS,
  QUERY_LIMIT,
  REQUIREMENTS_CHOICES,
  SORTING_ASC,
  SORTING_DESC,
} from "./constant.js"

import React, {Component, Fragment} from "react";
import api from "../../../api.js";
import { clone, isEqual } from '../../services/lodashInJS.js';
import Tooltip from "rc-tooltip";
import {connect} from "react-redux";
import {isString} from "validate.js";
import {withRouter} from "react-router-dom";
import {ArrowDown, ArrowUp, Filter, Search, User, X} from "react-feather";
import sitemap from '../../../shared/media/svg/sitemap.svg';

import Date from "../Moment/Date.jsx";
import CardRow from "../Styled/Card/CardRow.jsx";
import CardCol from "../Styled/Card/CardCol.jsx";
import FreelancePage from "../Styled/Containers/FreelancePage.jsx";
import Loader from '../../../shared/components/Loader/Loader.jsx';

import FilterRequirements from "../SearchBar/components/FilterRequirements/FilterRequirements.jsx";
import FreelanceListFilters from "./components/FreelanceListFilters/FreelanceListFilters.jsx";
import Pagination from "./components/Pagination.jsx";
import SearchInput from "../SearchInput/SearchInput.jsx";
import ShortcutsFilterBar from "./components/ShortcutsFilterBar/ShortcutsFilterBar.jsx";
import ToggleActiveFilters from "./components/ToggleActiveFilters/ToggleActiveFilters.jsx";
import SkillsTreeModal from '../Modals/SkillsTreeModal/SkillsTreeModal.jsx';

class FreelanceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      fetched: false,
      counts: {
        total: undefined,
        results: undefined,
      },
      pagination: {current: undefined},
      results: undefined,
      page: 1,
      sorting: DEFAULT_SORTING,
      keywords: undefined,
      requirements: undefined,
      checkedFilters: [],
      searchFilters: [],
      activeSearchFilters: [],
      choices: {
        universes: [],
        agents: []
      },
      isToggleFilterCheckboxesOpen: false,
      activeShortcutFilter: undefined,
      preventDataUpdate: undefined,
      skillsModal: false,
    }

    this.column = [
      {
        headerLabel: "FL ID",
        filterKey: FILTER_KEYS.ID,
        fieldKey: FIELD_KEYS.ID,
        onFieldClick: (id) => {
          this.goToFreelanceProfile(id)
        },
      },
      {
        headerLabel: "Prénom",
        filterKey: FILTER_KEYS.FIRSTNAME,
        fieldKey: FIELD_KEYS.FIRSTNAME,
        onFieldClick: (id) => {
          this.goToFreelanceProfile(id)
        },
      },
      {
        headerLabel: "Nom",
        filterKey: FILTER_KEYS.LASTNAME,
        fieldKey: FIELD_KEYS.LASTNAME,
        onFieldClick: (id) => {
          this.goToFreelanceProfile(id)
        },
      },
      {
        headerLabel: "Univers",
        filterKey: FILTER_KEYS.UNIVERSE,
        fieldKey: FIELD_KEYS.UNIVERSE,
      },
      {
        headerLabel: "Propriétaire",
        filterKey: FILTER_KEYS.AGENT,
        fieldKey: FIELD_KEYS.AGENT,
        fieldType: FIELD_TYPES.OBJECT,
        fieldComposedKeys: ['firstname', 'lastname'],
      },
      {
        headerLabel: "Dernier commentaire",
        filterKey: FILTER_KEYS.LAST_COMMENT,
        fieldKey: FIELD_KEYS.LAST_COMMENT,
        fieldType: FIELD_TYPES.DATE,
      },
      {
        headerLabel: "Dernière modification mission",
        filterKey: FILTER_KEYS.EXPERIENCES_LAST_UPDATE,
        fieldKey: FIELD_KEYS.EXPERIENCES_LAST_UPDATE,
        fieldType: FIELD_TYPES.DATE,
      },
      {
        headerLabel: "Disponibilité",
        filterKey: FILTER_KEYS.AVAILABLE,
        fieldKey: FIELD_KEYS.AVAILABLE,
        fieldType: FIELD_TYPES.DATE,
      },
      {
        headerLabel: "Création du profil",
        filterKey: FILTER_KEYS.CREATED,
        fieldKey: FIELD_KEYS.CREATED,
        fieldType: FIELD_TYPES.DATE,
      },
      {
        headerLabel: "DC uploadé",
        filterKey: FILTER_KEYS.SKILLS_FILE_UPLOADED,
        fieldKey: FIELD_KEYS.SKILLS_FILE_UPLOADED,
      },
      {
        headerLabel: "Linkedin",
        filterKey: FILTER_KEYS.HAS_LINKEDIN,
        fieldKey: FIELD_KEYS.HAS_LINKEDIN,
      },
      {
        headerLabel: "Retard",
        filterKey: FILTER_KEYS.LATE,
        fieldKey: FIELD_KEYS.LATE,
      },
      {
        headerLabel: "RDV pris",
        filterKey: FILTER_KEYS.MEETING_BOOKED,
        fieldKey: FIELD_KEYS.MEETING_BOOKED,
      },
      {
        headerLabel: "Vu en RDV",
        filterKey: FILTER_KEYS.SEEN,
        fieldKey: FIELD_KEYS.SEEN,
      },
      {
        headerLabel: "Complet",
        filterKey: FILTER_KEYS.COMPLETE,
        fieldKey: FIELD_KEYS.COMPLETE,
      },
      {
        headerLabel: "CDI",
        filterKey: FILTER_KEYS.CDI,
        fieldKey: FIELD_KEYS.CDI,
      },
    ]
  }
  componentDidMount() {
    // fill choices
    this.fetchUniverses()
    this.updateData()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {state: currentState} = this

    if(!isEqual(currentState.choices.universes, prevState.choices.universes)){
      this.fetchAgents()
    }

    const querySearchParams  = new URLSearchParams(document.location.search)
    if (querySearchParams.get('shortcut') && !this.state.activeShortcutFilter) {
      this.handleActiveShortcutFromSearchQuery(querySearchParams.get('shortcut'))
    }
  }

  handleActiveShortcutFromSearchQuery = (activeShortcut) => {
    const {history, location} = this.props
    const {fillCheckedFilters} = this

    let filtersCfg = FILTER_SHORTCUTS[activeShortcut]

    const {currentUser} = this.props
    filtersCfg = [
      ...filtersCfg,
      {field: FILTER_KEYS.AGENT, value: currentUser.id}
    ]

    const data = {
      checkedFilters: fillCheckedFilters(filtersCfg),
      activeShortcutFilter: activeShortcut,
      searchFilters: filtersCfg,
      activeSearchFilters: filtersCfg,
    }

    this.setState(data, () => this.updateData())
    history.replace(location.pathname)
  }

  fetchUniverses = async () => {
    api.universes.getAll()
      .then((response) => {
        this.setState({
          choices: {
            ...this.state.choices,
            universes: response.data
          }
        }
        )
      })
  }
  fetchAgents = async () => {
    const {choices} = this.state
    if(choices.universes.length > 0) {
      this.setState({
        choices: {
          ...choices,
          agents: []
        }})
      choices.universes.forEach((universe) => {
        this.fetchAgentsByMainUniverse(universe)
      })
    }

  }
  fetchAgentsByMainUniverse = async (universe) => {
    api.users.getBusinessManagersByMainUniverse({universe: universe.id})
      .then((response) => {
        this.setState({
          choices: {
            ...this.state.choices,
            agents: [
              ...this.state.choices.agents,
              ...response.data
            ]
          }
        })
      })
  }
  fetchFreelances = async () => {
    const {sorting, keywords, requirements, activeSearchFilters} = this.state

    // ℹ️ required to prevent error 500
    const handleEmptyValues = activeSearchFilters.map((filter) => {
      if (filter.value) {
        return filter
      }
      return {
        ...filter,
        value: null,
      }
    })

    return await (api.freelances.list({
      limit: QUERY_LIMIT,
      page: this.state.page,
      ...(sorting? {sorting} : {}),
      ...(keywords? {keywords} : {}),
      ...(requirements? {requirements} : {}),
      ...(activeSearchFilters? {filters: handleEmptyValues} : {}),
    }))
  }
  updateData = () => {
    this.setState({fetching: true, fetched: false,})
    this.fetchFreelances()
      .then((response) => {
        const responseData = response.data
        if(!responseData.results) {
          responseData['results'] = []
        }

        this.setState({
          ...this.state,
          ...responseData,
          fetched: true,
        })
      })
      .catch((error) => {
        console.error({error})
      })
      .finally(() => {
        this.setState({fetching: false, fetched: true})
      })
  }

  goToFreelanceProfile = (id) => {
    const currentLocation = window.location
    
    if(!id) {
      return
    }

    if(currentLocation.origin) {
      window.open(`${currentLocation.origin}/freelance/${id}` ,'_blank')
    }
  }

  getColumnValue = (row, key, type , extra, defaultValue = null) => {
    const data = key.split('.').reduce((acc, k) => acc?.[k], row) ?? defaultValue;

    if(!type) {
      if(typeof data === 'string' || data instanceof String) {
        return data
      }
      if(typeof data === "boolean") {
        return data ? 'Oui' : 'Non'
      }
      if(typeof data === "number") {
        return String(data)
      }
    }

    if(type === FIELD_TYPES.DATE) {
      return <Date date={data} />
    }

    if(type === FIELD_TYPES.OBJECT) {
      if(typeof data === "object") {
        if(!data || !extra.fieldComposedKeys) {
          return null
        }
        let response = ''
        extra.fieldComposedKeys.forEach((nestedFieldKeys) => {
          response = `${response} ${data[nestedFieldKeys]}`
        })
        return  response
      }
    }

    return null
  }
  sortingBy = (key) => {
    let direction = SORTING_ASC
    const {sorting: currentSorting} = this.state

    if(currentSorting) {
      if(currentSorting[key]) {
        direction = (currentSorting[key] === SORTING_DESC)
          ? SORTING_ASC
          : SORTING_DESC
      }
    }

    const sorting = {}
    sorting[key] = direction
    this.setState({sorting: sorting}, () => this.updateData())
  }
  checkSorting = (key) => {
    const {sorting: currentSorting} = this.state
    if(currentSorting && currentSorting[key]) {
      return currentSorting[key] === SORTING_DESC ? <ArrowDown size={18}/>: <ArrowUp size={18}/>
    }
    return null
  }
  handlePaginationFirstClick = () => {
    const firstPage = this.state.pagination.first
    if(!firstPage) {
      return
    }
    this.setState({page: firstPage}, () => this.updateData())
  }
  handlePaginationLastClick = () => {
    const lastPage = this.state.pagination.last
    if(!lastPage) {
      return
    }
    this.setState({page: lastPage}, () => this.updateData())
  }
  handlePaginationNextClick = () => {
    const nextPage = this.state.pagination.next
    if(!nextPage) {
      return
    }
    this.setState({page: nextPage}, () => this.updateData())
  }
  handlePaginationPreviousClick = () => {
    const previousPage = this.state.pagination.previous
    if(!previousPage) {
      return
    }
    this.setState({page: previousPage}, () => this.updateData())
  }
  onKeywordsChange = (newVal) => {
    this.setState({keywords: newVal}, () => this.updateData());
  }
  onRequirementsChange = (value) => {
    this.setState({requirements: value}, () => this.updateData());
  }
  hasFilterActive = (filter) => {
    const {checkedFilters} = this.state
    return checkedFilters.findIndex((activeFilter) => filter.filterKey === activeFilter.filterKey) >= 0
  }
  onCheckboxClick = (filter) => {
    const {checkedFilters, searchFilters} = this.state
    let initData = [...searchFilters,]

    const foundIndex = checkedFilters.findIndex((activeFilter) => {
      return filter.filterKey === activeFilter.filterKey
    })

    if(foundIndex >= 0) {
      // if checkbox should be disabled, should remove it from filters
      const removeFilter = initData.filter((item) => {
        return item.field !== filter.filterKey
      })

      checkedFilters.splice(foundIndex, 1)
      this.setState({
        checkedFilters: [
          ...checkedFilters
        ],
        activeSearchFilters: [...removeFilter],
        searchFilters: [...removeFilter],
      })
      return
    }

    // ℹ️ if filter is boolean type we should initialize select filter value
    if(filter.type === FIELD_TYPES.BOOLEAN) {
      initData = [
        ...initData,
        {field: filter.filterKey, value: filter.defaultValue},
      ]
    }

    this.setState({
      ...this.state,
      activeShortcutFilter: undefined,
      checkedFilters: [
        ...checkedFilters,
        filter
      ],
      activeSearchFilters: initData,
      searchFilters: initData,
    })
  }
  onSubmitFilters = (searchFilters, extraData= {}) => {
    const {first: firstPage } = this.state.pagination

    this.setState({
      searchFilters: searchFilters,
      activeSearchFilters: searchFilters,
      page: firstPage ? firstPage : 1,
      ...extraData,
    }, () => this.updateData())
  }

  deleteFilter = (filter) => {
    const {
      checkedFilters,
      searchFilters,
    } = this.state

    const copy = clone(searchFilters)
    const foundActiveFilterIndex = checkedFilters.findIndex((activeFilter) => {
      return activeFilter.filterKey === filter.filterKey
    })

    if(foundActiveFilterIndex >= 0) {
      checkedFilters.splice(foundActiveFilterIndex, 1)
    }

    const foundSearchFilterIndex = copy.findIndex((searchFilter) => {
      return searchFilter.field === filter.filterKey
    })

    if(foundSearchFilterIndex >= 0) {
      copy.splice(foundSearchFilterIndex, 1)
    }

    this.setState({
      checkedFilters: [...checkedFilters],
      searchFilters: [...copy],
      activeSearchFilters: [...copy],
      activeShortcutFilter: undefined
    }, () => this.updateData())
  }
  deleteAllFilters = () => {
    this.setState({
      checkedFilters: [],
      searchFilters: [],
      activeSearchFilters: [],
    }, () => this.updateData())
  }
  getDefaultValues = () => {
    const {searchFilters} = this.state
    const defaultValues = {}
    searchFilters.forEach((filter) => {
      if(filter.comparison) {
        const newValue = (defaultValues[filter.field] && typeof defaultValues[filter.field].value === "object")
          ? defaultValues[filter.field].value
          : {}
        newValue[filter.comparison] = filter.value
        defaultValues[filter.field] = {
          value: newValue,
        }
        return
      }

      defaultValues[filter.field] = {
        value: filter.value,
      }
    })
    return defaultValues
  }
  toggleFilterCheckboxes = () => {
    this.setState({isToggleFilterCheckboxesOpen: !this.state.isToggleFilterCheckboxesOpen})
  }
  getSearchInputPlaceholder = () => {
    const {requirements} = this.state
    if(!requirements) {
      return `Rechercher un Nom / Prénom`
    }

    if(requirements === 1) {
      return `Rechercher un ID`
    }

    if(requirements === 2) {
      return `Rechercher un Email`
    }

    if(requirements === 3) {
      return `Rechercher un Téléphone`
    }

    return `Rechercher ...`
  }

  onShortcutClick = (shortcutFilterKey, fillOwnerFilter) => {
    const filtersCopy = clone(FILTER_SHORTCUTS)
    let shortcutFilter = shortcutFilterKey

    let data = {}

    if (isString(shortcutFilterKey)) {
      // ℹ️ set/toggle active shorcut
      const toggledShortcutFilter = (this.state.activeShortcutFilter === shortcutFilter)
        ? undefined
        : shortcutFilter

      shortcutFilter = filtersCopy[shortcutFilterKey]

      if(!toggledShortcutFilter) {
        // reset filters
        this.setState({
          activeShortcutFilter: undefined,
          checkedFilters: [],
          searchFilters: [],
          activeSearchFilters: [],
        }, () => this.updateData())
        return
      }

      data = {
        activeShortcutFilter: toggledShortcutFilter,
        searchFilters: shortcutFilter,
        activeSearchFilters: [],
      }
    }

    if(fillOwnerFilter) {
      const {currentUser} = this.props
      shortcutFilter = [
        ...shortcutFilter,
        {field: FILTER_KEYS.AGENT, value: currentUser.id}
      ]
    }

    let flattenedFilters = []
    FILTER_GROUPS.forEach((group) => {
      flattenedFilters = [
        ...flattenedFilters,
        ...group.filters
      ]
    })

    let checkedFilters = []
    shortcutFilter
      .forEach((searchFilter) => {
        const found = flattenedFilters.find((filter) => {
          return filter.filterKey === searchFilter.field
        })
        if(found) {
          checkedFilters = [
            ...checkedFilters,
            found,
          ]
        }
      })

    this.setState({
      ...data,
      checkedFilters: this.fillCheckedFilters(shortcutFilter),
      searchFilters: clone(shortcutFilter),
      activeSearchFilters: clone(shortcutFilter),
    }, () => this.updateData())
  }

  fillCheckedFilters = (filters) => {
    let flattenedFilters = []
    FILTER_GROUPS.forEach((group) => {
      flattenedFilters = [
        ...flattenedFilters,
        ...group.filters
      ]
    })

    let checkedFilters = []
    filters
      .forEach((searchFilter) => {
        const found = flattenedFilters.find((filter) => {
          return filter.filterKey === searchFilter.field
        })
        if(found) {
          checkedFilters = [
            ...checkedFilters,
            found,
          ]
        }
      })
    return checkedFilters
  }

  toggleSkillsModal = () => {
    this.setState((prevState) => ({
      skillsModal: !prevState.skillsModal
    }));
  };
  render() {
    const {
      checkSorting,
      column,
      deleteAllFilters,
      deleteFilter,
      getColumnValue,
      getDefaultValues,
      getSearchInputPlaceholder,
      hasFilterActive,
      onCheckboxClick,
      onKeywordsChange,
      onRequirementsChange,
      onShortcutClick,
      onSubmitFilters,
      sortingBy,
      toggleFilterCheckboxes,
      toggleSkillsModal,
    } = this

    const {
      checkedFilters,
      choices,
      counts,
      fetching,
      fetched,
      isToggleFilterCheckboxesOpen,
      pagination,
      results,
      requirements,
      activeShortcutFilter,
    } = this.state

    if(fetching || !fetched) {
      return (
        <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
          Chargement...
        </Loader>
      )
    }

    const defaultValues = getDefaultValues()

    return (
      <Fragment>
        <div className="bg-gray-100">
          {/* ℹ️ Searchbar */}
          <CardRow className="freelance-list-search" align="center" gap="1rem">
            <CardCol flex="auto" className="freelance-list-search-col">
              <CardRow justify="space-between" gap="0rem" align="center">
                <CardCol flex="auto">
                  <SearchInput
                    placeholder={getSearchInputPlaceholder()}
                    className="input-search"
                    value={this.state.keywords}
                    onChange={onKeywordsChange}
                    style={{
                      width: '100%',
                    }}
                  />
                </CardCol>
                <CardCol>
                  <Search size={24}/>
                </CardCol>
              </CardRow>
            </CardCol>
            <CardCol className="separator" />
            <CardCol className={`icon-col search-filter-skills`}>
              <div className="icon-wrapper">
                <Tooltip placement={"bottom"} overlay={'Arbre de compétences'}>
                  <img style={{width: "24px"}} src={sitemap} alt="Arbre de compétences" onClick={toggleSkillsModal} />
                </Tooltip>
              </div>
            </CardCol>
            <CardCol className="separator" />
            <CardCol flex="unset">
              <FilterRequirements
                value={requirements}
                choices={REQUIREMENTS_CHOICES}
                onChange={onRequirementsChange}
              />
            </CardCol>
            <CardCol className="separator" />
            <CardCol flex="unset">
              <User size={24}/> {counts.results} / {counts.total}
            </CardCol>
          </CardRow>

          {/* ℹ️ Filterbar */}
          <CardRow
            className="freelance-list-filterbar"
            align="center"
            justify="space-between"
            gap="1rem">

            {/* ℹ️ Mobile */}
            <ShortcutsFilterBar
              activeShortcut={activeShortcutFilter}
              isMobile={true}
              onShortcutClick={(key, withOwnerFilter = false) => {
                onShortcutClick(key, withOwnerFilter)
                toggleFilterCheckboxes()
              }}/>

            {/* ℹ️ Desktop */}
            <ShortcutsFilterBar
              activeShortcut={activeShortcutFilter}
              onShortcutClick={onShortcutClick}/>
            <CardCol flex="unset" className="separator" />
            <CardCol flex="unset">
              <div className="toggle-filter-checkboxes" onClick={toggleFilterCheckboxes}>
              Ajouter un filtre <Filter size="20"/>
              </div>
            </CardCol>
          </CardRow>

          {isToggleFilterCheckboxesOpen
            ?
            <Fragment>
              <div className="freelance-list-filters-wrapper">
                <div className={'only-for-mobile'}>
                  <div className="close-action" onClick={toggleFilterCheckboxes}> <X size={30}/> </div>

                  <label className={'only-for-mobile'} htmlFor=""> Filtres Sélectionnés : </label>
                  <FreelanceListFilters
                    choices={choices}
                    defaultValues={defaultValues}
                    checkedFilters={checkedFilters}
                    onDeleteFilter={deleteFilter}
                    onDeleteAllFilters={deleteAllFilters}
                    onSubmit={(filters) => {
                      onSubmitFilters(filters, {isToggleFilterCheckboxesOpen: false})
                    }}
                  />
                  <label className={'only-for-mobile'} htmlFor=""> Ajouter un filtre : </label>
                </div>
                <ToggleActiveFilters
                  filterGroups={FILTER_GROUPS}
                  onCheckboxClick={onCheckboxClick}
                  hasFilterActive={hasFilterActive}/>
              </div>
            </Fragment>
            : null
          }

          {/* ℹ️ Hide for mobile */}
          <FreelanceListFilters
            choices={choices}
            defaultValues={defaultValues}
            checkedFilters={checkedFilters}
            onDeleteFilter={deleteFilter}
            onDeleteAllFilters={deleteAllFilters}
            onSubmit={onSubmitFilters}
          />

          <FreelancePage style={{margin: '1rem auto'}}>
            <CardRow justify="center">
              <Pagination
                current={pagination?.current ? pagination.current : 0}
                hasNext={!!pagination.next}
                hasPrevious={!!pagination.previous}
                onFirstClick={this.handlePaginationFirstClick}
                onLastClick={this.handlePaginationLastClick}
                onNextClick={this.handlePaginationNextClick}
                onPreviousClick={this.handlePaginationPreviousClick}
              />
            </CardRow>
            <CardRow className="freelance-list-table-wrapper" justify="center">
              <table className={'freelance-list-table'}>
                <thead>
                  <tr>
                    {column.map((column) => {
                      return (
                        <Tooltip placement="top" overlay={column.headerLabel} key={`header-column-${column.filterKey}`}>
                          <th
                            onClick={() => sortingBy(column.filterKey)}>
                            <Fragment>
                              {checkSorting(column.filterKey)} {column.headerLabel}
                            </Fragment>
                          </th>
                        </Tooltip>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {(this.state?.results ?? null) && results.map((resultRow, index) => {
                    return (
                      <tr key={`filtered-row-${index}`}>
                        {column.map((column) => {
                          return (
                            <td
                              key={`header-column-${column.fieldKey}`}
                              onClick={(column.onFieldClick) ? () => column.onFieldClick(resultRow.id) : null}
                              className={`${(column.onFieldClick) ? 'clickable' : ''}`}
                            >
                              {getColumnValue(resultRow, column.fieldKey, column.fieldType, {
                                fieldComposedKeys: column.fieldComposedKeys
                              })}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </CardRow>
            <CardRow justify="center" p="1rem 0">
              <Pagination
                current={pagination?.current ? pagination.current : 0}
                hasNext={!!pagination.next}
                hasPrevious={!!pagination.previous}
                onFirstClick={this.handlePaginationFirstClick}
                onLastClick={this.handlePaginationLastClick}
                onNextClick={this.handlePaginationNextClick}
                onPreviousClick={this.handlePaginationPreviousClick}
              />
            </CardRow>
          </FreelancePage>
        </div>

        <SkillsTreeModal
          modal={this.state.skillsModal} 
          toggle={toggleSkillsModal} 
        />
      </Fragment>
    )
  }
}

export default connect(state => ({
  currentUser: state?.currentUser.user
}))(withRouter(FreelanceList))